import { useCallback } from 'react';

import { useOnPlayingStateChanged } from '@/scenarios/legacy-player/hooks/useOnPlayingStateChanged';
import { PlayingState } from '@/scenarios/legacy-player/types/instance';

export const useOnFilmEnd = (onClose?: () => void) => {
    const onPlayingStateChanged = useCallback(
        (playingState: PlayingState | undefined) => {
            if (playingState === PlayingState.end) {
                onClose?.();
            }
        },
        [onClose]
    );

    useOnPlayingStateChanged(onPlayingStateChanged);
};
